
<template>
    <div>
        <b-alert show variant="info" v-for="homework in homeworks" :key="homework.id">
            <b-row>
                <b-col cols="12" md="10">
                    <b-button variant="primary">
                        {{ homework.name+' '+homework.surname }} <b-badge variant="warning" class="ml-2">{{ $t('student_number')+':'+homework.student_number }}</b-badge>
                    </b-button>
                </b-col>
                <b-col cols="12" md="2" class="d-flex justify-content-end">
                    <b-button v-if="homework.file"
                              @click="downloadStudentFile(homework.file.uuid, homework.file.file_name)"
                              class="mr-2"
                              squared
                              variant="primary"
                              v-b-tooltip.hover
                              :title="homework.file.file_name">
                        <i class="ri-file-download-line" style="font-size: 20px"></i>
                    </b-button>
                </b-col>
            </b-row>
        </b-alert>
    </div>
</template>
<script>

import LmsHomeWorkEntryService from "@/services/LmsHomeWorkEntryService"
import qs from "qs";

export default {
    components: {

    },
    props: {
        formId: {
            type: Number
        },
        semesterId: {},
    },
    data() {
        return {
            homeworks: null
        }
    },

    created() {
        this.getData()
    },

    methods: {
        getData () {
            const config = {
                params: {
                    filter: {
                        lms_homework_id: this.formId
                    },
                    limit: -1,
                },
                paramsSerializer: (params) => qs.stringify(params, {encode: false})
            }
            LmsHomeWorkEntryService.getHomeworks(config).then(response => {
                this.homeworks = response.data.data
            }).catch(e => {
                this.showErrors(e, null)
            })
        },

        downloadStudentFile(uuid, filename) {
            LmsHomeWorkEntryService.downloadSudentFile(uuid).then(response=>{
                this._downloadFile(response, filename)
            }).catch(e => {
                this.showErrors(e, null)
            })
        }
    }

};
</script>
